import { render, staticRenderFns } from "./IcebergDetectionView.vue?vue&type=template&id=23a5c752&scoped=true"
import script from "./IcebergDetectionView.vue?vue&type=script&lang=js"
export * from "./IcebergDetectionView.vue?vue&type=script&lang=js"
import style0 from "./IcebergDetectionView.vue?vue&type=style&index=0&id=23a5c752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a5c752",
  null
  
)

export default component.exports